import React, { useEffect } from "react";
import SimpleSlider from "./SimpleSlider"; // Adjust the path if necessary
import { RiHome2Line } from "react-icons/ri";
import Pageheading from "../PageHeading/Pageheading";
import { useWindowSize } from "react-use";
import contactimg from "../../assets/AboutUs/Banner.png";
import mobileimg from "../../assets/AboutUs/Banner_Mobile.png";
import BannerHeading from "../BannerHeading/Heading";

const Section1 = () => {
  const { width } = useWindowSize();
  useEffect(() => {
    const preloadImages = [contactimg, mobileimg];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);
  return (
    <div className="relative w-full h-[90vh] md:h-[40vw] 3xl:h-[60vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-10">
        <div className="md:pl-[5.63vw] pl-4 flex items-center md:pt-[10.09vw] pt-[25vw]">
          <Pageheading pageHeading={"About Us"} icon={<RiHome2Line />} />
        </div>
      </div>
      <div
        className="absolute inset-0 bg-cover bg-no-repeat bg-bottom flex justify-center items-center"
        style={{
          backgroundImage: `url(${width < 768 ? mobileimg : contactimg})`,
        }}
      >
        {/* <div className="absolute w-full justify-center top-[40vw]  md:top-[15vw] md:left-[17.47vw] flex md:justify-start md:items-center z-10">
          <BannerHeading headingText={"ABOUT US"} />
        </div> */}
        <div className="absolute w-full justify-center top-[25vh] md:top-[15vw] md:left-[17.47vw] flex md:justify-start md:items-center z-10">
          <BannerHeading headingText={"ABOUT US"} />
        </div>
      </div>
      <div className="absolute h-[250px] md:h-[300px] tab:h-[327px] w-full top-0 bg-gradient-to-b from-[#121614]"></div>
    </div>
  );
};

export default Section1;
